import React from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';

import useOrder from 'src/components/enterprise/features/OrderHistory/OrderReceipt/useOrder';
import Loader from 'src/components/enterprise/features/OrderHistory/OrderReceipt/Loader';
import { OrderReceipt } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/OrderReceipt';
import { mapOrderToReceiptProps } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/mapOrderToReceiptProps';

export default function OrderReceiptContainer(): JSX.Element {
  const order = useOrder();
  const { corpData } = useAuth();

  const isLoading = !order;

  if (isLoading) return <Loader />;

  return <OrderReceipt {...mapOrderToReceiptProps(order, corpData)} />;
}
